<template>
  <div
      v-if="visible"
      class="album-download-progress-overlay album-studio-progress"
      role="dialog"
      aria-modal="true"
      aria-live="polite"
  >
    <div class="album-download-progress-card">
      <i class="el-icon-loading album-download-progress-card__icon"></i>
      <h3 class="album-download-progress-card__title">{{ title }}</h3>
      <p class="album-download-progress-card__message">{{ message }}</p>
      <div v-if="indeterminate" class="album-progress-indeterminate" role="progressbar" :aria-label="title"><span /></div>
      <el-progress v-else
          :percentage="safePercentage"
          :show-text="false"
          :color="colors"
          class="album-download-progress-card__bar"
      ></el-progress>
      <div v-if="!indeterminate" class="album-download-progress-card__percent">{{ safePercentage }}%</div>
      <p class="album-download-progress-card__note">{{ indeterminate ? 'Khi bắt đầu tải, bạn có thể theo dõi tiến trình trong trình duyệt.' : 'Vui lòng không đóng trang trong quá trình tải.' }}</p>
    </div>
  </div>
</template>

<script>
import "../styles/album-studio.scss";
export default {
  name: "AlbumDownloadProgressDialog",
  props: {
    indeterminate: {type: Boolean, default: false},
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Đang chuẩn bị tải",
    },
    message: {
      type: String,
      default: "Đang tạo liên kết tải xuống...",
    },
    percentage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      colors: [
        {color: "#9bd4dc", percentage: 20},
        {color: "#65b6b5", percentage: 40},
        {color: "#4b91c5", percentage: 60},
        {color: "#477ab8", percentage: 80},
        {color: "#6f79bd", percentage: 100},
      ],
    };
  },
  computed: {
    safePercentage() {
      return Math.max(0, Math.min(100, Number(this.percentage) || 0));
    },
  },
};
</script>
